/**
 * Helper para subir imágenes a Cloudinary con firma del backend.
 * Uso: const { secure_url, public_id } = await uploadToCloudinary(file, "dnf/componentes");
 */
import api from "@/lib/api";

export async function uploadToCloudinary(file, folder = "dnf/componentes", resourceType = "image") {
  const { data: sig } = await api.get(`/cloudinary/signature?folder=${encodeURIComponent(folder)}&resource_type=${resourceType}`);

  const form = new FormData();
  form.append("file", file);
  form.append("api_key", sig.api_key);
  form.append("timestamp", sig.timestamp);
  form.append("signature", sig.signature);
  form.append("folder", sig.folder);

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${sig.cloud_name}/${resourceType}/upload`,
    { method: "POST", body: form }
  );

  // Leemos el body UNA sola vez como texto y luego parseamos.
  // Esto evita "TypeError: body stream already read" si algo intercepta el stream.
  let raw = "";
  try {
    raw = await res.text();
  } catch (e) {
    // Si el stream ya fue consumido por algún interceptor / extensión del navegador
    throw new Error(`Cloudinary upload error: respuesta ilegible (${res.status})`);
  }

  if (!res.ok) {
    let msg = raw;
    try { msg = JSON.parse(raw)?.error?.message || raw; } catch (_) {}
    throw new Error(`Cloudinary upload error: ${res.status} ${msg}`);
  }

  let data;
  try {
    data = JSON.parse(raw);
  } catch (e) {
    throw new Error(`Cloudinary upload error: respuesta no JSON (${res.status})`);
  }
  return {
    secure_url: data.secure_url,
    public_id: data.public_id,
    width: data.width,
    height: data.height,
    bytes: data.bytes,
    resource_type: data.resource_type,
    format: data.format,
  };
}

/** Devuelve una URL con transformación de Cloudinary (thumbnail, fit, etc.). */
export function cloudinaryThumb(url, w = 200, h = 200) {
  if (!url || !url.includes("/upload/")) return url;
  return url.replace("/upload/", `/upload/c_fill,w_${w},h_${h},q_auto,f_auto/`);
}

/** F3 · src de imagen de un componente: miniatura Cloudinary si hay URL http; base64 histórico → original on-demand (cookie auth). */
export function componenteImgSrc(c, w = 200, h = 200) {
  if (!c) return null;
  if (c.imagen_url && c.imagen_url.startsWith("http")) return w ? cloudinaryThumb(c.imagen_url, w, h) : c.imagen_url;
  if (c.imagen_url && c.imagen_url.startsWith("data:")) return c.imagen_url;   // compat: respuestas antiguas / caché
  if (c.imagen_original_url) return `${process.env.REACT_APP_BACKEND_URL}${c.imagen_original_url}`;
  return null;
}
